var map = {
	"./admin.svg": 6190,
	"./bianji.svg": 4704,
	"./component.svg": 250,
	"./config.svg": 907,
	"./dangdifill.svg": 6439,
	"./daohang.svg": 583,
	"./deal.svg": 3175,
	"./duanxin.svg": 2770,
	"./geren.svg": 3676,
	"./jiesuo.svg": 9942,
	"./job.svg": 6630,
	"./live.svg": 1963,
	"./log.svg": 4193,
	"./menu.svg": 8804,
	"./mobile.svg": 8015,
	"./mudedi.svg": 1427,
	"./oss.svg": 734,
	"./pinglun.svg": 8946,
	"./plan.svg": 5452,
	"./procure.svg": 7509,
	"./production.svg": 9556,
	"./role.svg": 3637,
	"./sale.svg": 2152,
	"./screen.svg": 3309,
	"./shanchu.svg": 3169,
	"./shezhi.svg": 1900,
	"./shoucang.svg": 589,
	"./shoucangfill.svg": 1298,
	"./shouye.svg": 9334,
	"./sousuo.svg": 5475,
	"./sql.svg": 7111,
	"./suoding.svg": 8924,
	"./system.svg": 4518,
	"./tixing.svg": 740,
	"./xiangqu.svg": 2342,
	"./xiangqufill.svg": 5317,
	"./zhedie.svg": 6614,
	"./zonghe.svg": 5212
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1525;